/* Keep Uploadly's late-injected inline styles from hiding the engraving control. */
(function () {
  var labelStyles = ['color', 'font-weight'];
  var buttonStyles = ['width', 'height', 'font-size', 'font-weight', 'line-height', 'padding', 'color', 'background', 'background-color', 'border', 'border-width', 'border-style', 'border-color', 'outline', 'margin-top'];
  function clearStyles(element, properties) {
    properties.forEach(function (property) {
      if (element.style.getPropertyValue(property)) element.style.removeProperty(property);
    });
  }
  function normalize(app) {
    app.querySelectorAll('[data-ph-fieldname] > p').forEach(function (label) { clearStyles(label, labelStyles); });
    app.querySelectorAll('.uploadcare--widget__button_type_open').forEach(function (button) { clearStyles(button, buttonStyles); });
  }
  function connect() {
    var app = document.getElementById('photouploadapp');
    if (!app) return false;
    normalize(app);
    new MutationObserver(function () { normalize(app); }).observe(app, {childList: true, subtree: true, attributes: true, attributeFilter: ['style']});
    return true;
  }
  if (!connect()) {
    var waiting = new MutationObserver(function () { if (connect()) waiting.disconnect(); });
    waiting.observe(document.body, {childList: true, subtree: true});
  }
})();
